import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import IconButton from 'components/Luxkit/Button/IconButton'
import LineMinusIcon from 'components/Luxkit/Icons/line/LineMinusIcon'
import SolidPlusIcon from 'components/Luxkit/Icons/solid/SolidPlusIcon'

const ZoomButtonContainer = styled.div`
  position: absolute;
  right: ${rem(20)};
  top: ${rem(90)};
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  border-radius: ${rem(2)};
`

const ShadowedIconButton = styled(IconButton)`
  background-color: white !important;
  box-shadow: ${(props) => props.theme.shadow.flat.small};
`

interface Props {
  mapRef: React.MutableRefObject<google.maps.Map | undefined>
}

const MAX_ZOOM = 20
const MIN_ZOOM = 2

function MapZoomButtons(props: Props) {
  const { mapRef } = props

  const currentZoom = mapRef.current?.getZoom()

  const zoomIn = () => {
    if (currentZoom) {
      mapRef.current?.setZoom(currentZoom + 1)
    }
  }

  const zoomOut = () => {
    if (currentZoom) {
      mapRef.current?.setZoom(currentZoom - 1)
    }
  }

  return (
    <ZoomButtonContainer>
      <ShadowedIconButton
        aria-label="Zoom in"
        title="Zoom in"
        kind="tertiary"
        disabled={currentZoom === MAX_ZOOM}
        onClick={zoomIn}
      >
        <SolidPlusIcon />
      </ShadowedIconButton>
      <ShadowedIconButton
        aria-label="Zoom out"
        title="Zoom out"
        kind="tertiary"
        disabled={currentZoom === MIN_ZOOM}
        onClick={zoomOut}
      >
        <LineMinusIcon />
      </ShadowedIconButton>
    </ZoomButtonContainer>
  )
}

export default MapZoomButtons
